import { atom } from 'recoil';

export const holderAtom = atom({
  key: 'holderAtom',
  default: {
    loading: false,
    item: null,
    items: [],
    error: null
  },
});

export const holderKeysAtom = atom({
  key: 'holderKeysAtom',
  default: {
    loading: false,
    item: null,
    items: [],
    error: null
  },
});